import type { State } from 'model/State';

export const selectCountriesByName = (state: State) => state.mac.country.countriesByName;

export const selectCountryByName = (state: State, countryName: string) =>
  state.mac.country.countriesByName?.[countryName?.toLowerCase()]?.ifSuccess((r) => r);
